<template>
  <section class="about">
    <h1>About Our Library</h1>
    <p>Welcome to our digital library! We're dedicated to providing a vast collection of books and resources to our community.</p>
  </section>
</template>

<script setup>
// No script needed for now
</script>

<style scoped>
.about {
  max-width: 800px;
  margin: 64px auto 0;
  text-align: center;  
}
</style>